import { render } from "./LayerCredits.vue?vue&type=template&id=3a86dc9e&scoped=true"
import script from "./LayerCredits.vue?vue&type=script&lang=js"
export * from "./LayerCredits.vue?vue&type=script&lang=js"

import "./LayerCredits.vue?vue&type=style&index=0&id=3a86dc9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a86dc9e"]])

export default __exports__